import request from '@/utils/request'
import APIS from '@/permissions/index'
// 分页查询回款记录
export function queryReleaseRecords (data) {
  return request({
    ...APIS['@flowDetail/Query_Release_Records'],
    data
  })
}

export function releaseResource (data) {
  return request({
    ...APIS['@flowDetail/Release_Resource'],
    data
  })
}

export function deleteReleaseRecord (params) {
  return request({
    ...APIS['@flowDetail/Delete_ReleaseRecord'],
    params
  })
}

// 查询相关资源配置(其他类型)
export function queryResourceOthers (params) {
  return request({
    ...APIS['@flowDetail/Query_ResourceOthers'],
    params
  })
}

export function queryProduct (params) {
  return request({
    ...APIS['@flowDetail/Query_Product'],
    params
  })
}

// 查询相关资源配置(代金券)
export function queryResourceAllocation (params) {
  return request({
    ...APIS['@flowDetail/Query_ResourceAllocation'],
    params
  })
}

export function releaseVoucherRsource (data) {
  return request({
    ...APIS['@flowDetail/Release_voucher_Rsource'],
    data
  })
}

// 查询相关资源配置(代金券)
export function recoveryResource (data) {
  return request({
    ...APIS['@flowDetail/Recovery_Resource'],
    data
  })
}

export function querySubsidyType (params) {
  return request({
    ...APIS['@flowDetail/Query_subsidyType'],
    params
  })
}

export function queryReleaseSubRecords (params) {
  return request({
    ...APIS['@flowDetail/Query_ReleaseSubRecords'],
    params
  })
}

export function queryRecover (params) {
  return request({
    ...APIS['@flowDetail/Query_Recover'],
    params
  })
}

export function importReleaseRecord (data) {
  return request({
    ...APIS['@flowDetail/Import_ReleaseRecord'],
    data
    // timeout: 300000
  })
}

export function exportReleaseRecord (data) {
  // const headers = {
  //   'Content-Type': 'application/octet-stream'
  // }
  // const responseType = 'arraybuffer'
  const responseType = 'blob'
  return request({
    ...APIS['@flowDetail/Export_ReleaseRecord'],
    data,
    responseType
  })
}

export function importRecoveryRecord (data) {
  return request({
    ...APIS['@flowDetail/Import_RecoveryRecord'],
    data
    // timeout: 300000
  })
}

export function queryProductFlowDetail (params) {
  return request({
    ...APIS['@flowDetail/Query_ProductFlowDetail'],
    params
  })
}

export function importReleaseRecordProgress (params) {
  return request({
    ...APIS['@flowDetail/Import_ReleaseRecordProgress'],
    params
  })
}

export function importRecoveryRecordProgress (params) {
  return request({
    ...APIS['@flowDetail/ImportRecoveryRecordProgress'],
    params
  })
}

export function updateVoucherResource (data) {
  return request({
    ...APIS['@flowDetail/Update_VoucherResource'],
    data
  })
}

export function updateRecoveryResource (data) {
  return request({
    ...APIS['@flowDetail/Update_RecoveryResource'],
    data
  })
}

export function deleteVoucherReleaseRecord (params) {
  return request({
    ...APIS['@flowDetail/Delete_VoucherReleaseRecord'],
    params
  })
}

export function pullData (params) {
  return request({
    ...APIS['@flowDetail/Pull_Data'],
    params
  })
}
